module.exports = __webpack_public_path__ + "img/webgl.fedfee12.png";